import React, { useState, useEffect} from "react";
import { apiClient } from "../api_client.js";

export default function UploadFile({eventId, onSuccess }) {

  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleFinSubmit = async (e) => {
    e.preventDefault();
    const fileInput = document.getElementById("csvInput");
      const file = fileInput.files[0];
    
      if (!file) {
        setIsSubmitting(false);
        showToast("Please select a CSV file.", "error");
        return;
      } else {
        setIsSubmitting(true);
      }
  
      const formData = new FormData();
      formData.append("csv_file", file);
  
      try {
        const response = await apiClient.events.uploadCSV(eventId, formData);
  
        setIsSubmitting(false);
        alert(response.success || "Entrants Uploaded Successfully");
        if (onSuccess){
          onSuccess();
        }
      } catch (err) {
      setIsSubmitting(false);
      console.error("Error uploading CSV:", err);
      showToast(err, "error");
    }
  }

  return (
    <div className="mt-2 mb-1">
      <h5 className="card-title mb-0">Upload Entrant Racers CSV</h5>
      <div className="card-body">
        <form onSubmit={handleFinSubmit}>
          <p>This CSV comes from a Fabbian 4 form. You may complete this step later if your entrant list is not ready.</p>
          <div className="mb-3">
            <input
              type="file"
              name="csv_file"
              id="csvInput"
              className="form-control"
              accept=".csv"
            />
          </div>

          <div id="upload-csv-button">
            <button
              type="submit" 
              className="btn btn-success"
              id="upload-csv"
            >
              Save Entrant List
            </button>
          </div>
          {onSuccess && (
            <button
              type="button"
              className="btn btn-secondary mt-2"
              onClick={() => onSuccess()}
            >
              Skip for now
            </button>
          )}
        </form>

        {isSubmitting && (
          <div className="progress mb-3">
            <div 
              className="progress-bar progress-bar-striped progress-bar-animated bg-info" 
              role="progressbar" 
              style={{ width: "100%" }}
            >
              Saving Entrants ...
            </div>
          </div>
        )}
      </div>
  </div>
  )
}